/* Client for the year-end promotion endpoints on the PEAR Render backend.
   Promotion is destructive (advances every student's grade), so the UI always
   previews before applying and the apply is idempotent per academic year. */
import { auth } from '../firebase';

const BASE = (process.env.REACT_APP_PAYMENTS_URL || '').replace(/\/$/, '');

export function isStudentsApiConfigured(): boolean {
  return !!BASE;
}

async function authedPost<T>(path: string, body: unknown): Promise<T> {
  if (!BASE) throw new Error('The backend is not configured (REACT_APP_PAYMENTS_URL).');
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('You appear to be signed out — please sign in again.');
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) throw new Error(json.error || 'Request failed');
  return json as T;
}

export interface PromotionPreviewRow {
  parentId: string;
  childId: string;
  childName?: string;
  from?: string;
  to?: string | null;
  graduated?: boolean;
  skip?: string;
}
export interface PromotionPreview {
  system: string;
  totals: { children: number; promoted: number; graduating: number; skipped: number };
  rows: PromotionPreviewRow[];
}

export function promotePreview(orgCode: string): Promise<PromotionPreview> {
  return authedPost('/api/students/promote-preview', { orgCode });
}

export function promoteApply(orgCode: string, academicYear: string): Promise<{ alreadyApplied: boolean; promoted?: number; graduating?: number }> {
  return authedPost('/api/students/promote-apply', { orgCode, academicYear });
}
